export default __webpack_public_path__ + "static/media/paper11.3b90fd81.JPG";